const customerNo = Number(localStorage.getItem('customerNo'))
export const COOKIE_CUSTOMER_NO = localStorage.getItem('customerNo');
export const COOKIE_USER_ID = localStorage.getItem('userId');
export const targetAccess = [503].includes(Number(customerNo));
export const Transporter = [1568].includes(Number(customerNo));
export const customerCompanyName = localStorage.getItem('customerCompanyName');
export const customerNameVal = localStorage.getItem('customerName');
export const customerLogo = localStorage.getItem('customerLogo');
export const setCustomerDetails = (key, value) => localStorage.setItem(key, value);
export const LOCAL_STORAGE = {
    COOKIE_USER_TOKEN: localStorage.getItem("apiToken"),
    COOKIE_USER_ID: localStorage.getItem('userId'),
    COOKIE_CUSTOMER_NO: localStorage.getItem('customerNo'),
    customerNo: localStorage.getItem('customerNo'),
    userId: localStorage.getItem('userId'),
    userToken: localStorage.getItem('apiToken'),
    customerLogo: localStorage.getItem('customerLogo'),
    role: localStorage.getItem('role'),
    customerCompanyName: localStorage.getItem('customerCompanyName'),
    customerName: localStorage.getItem('customerName'),
    // Note: Add new local storage items here
    // eg: customerNo: localStorage.getItem("customerNo")
}

export const mastersExportDisabled = ()=>{
    switch(customerNo.toString()){
        case '1545':
         return ["ADMINISTRATOR", "ELIXIR"].includes(LOCAL_STORAGE.role?.toString().toUpperCase()) ? false : true;
        default : 
         return false;
    }
}

export const FEATURES = {
    isMISReportEnabled : [1545].includes(Number(customerNo)),
    mastersExportDisabled
}

export const ASIDEDROPDOWN_CONSTANTS = {
    masters : {
        title : "Masters",
        expense : "Expense",
        billing_party : "Billing Party",
        branch : "Branch",
        product : "Product",
        consignee : "Consignee",
        consignor : "Consignor",
        target : "Target"
    },
    reports : {
        title : "Reports",
        MIS_REPORT: 'MIS Report'
    }
}
